import { Component, Inject, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";
import { SyndicateRepositoryService } from "src/app/pages/syndicate/syndicate-repository.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";

@Component({
  selector: "app-decline-syndicate",
  templateUrl: "./decline-syndicate.component.html",
  styleUrls: ["./decline-syndicate.component.scss"],
  standalone: true,
  imports: [IonicModule, TranslatePipe],
})
export class DeclineSyndicateComponent implements OnInit {
  userId: string;
  constructor(
    private firestore: Firestore,
    private matDialogRef: MatDialogRef<DeclineSyndicateComponent>,
    private syndicateService: SyndicateRepositoryService,
    private angularFireStore: AngularFirestore,
    private GTMSegment: GTMSegmentService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.GTMSegment.GTMPopupInitialization("DeclineInvitaion");
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("DeclineSyndicateComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
   }
  declineInvitation() {
    if (
      this.userId === "null" ||
      this.userId == null ||
      !this.data.psInvitation?.limb_msg_id
    ) {
      return;
    }

    const path_id = "i6Y4dDCDpxx6moWivjMh";
    const doc_data = { hide: true };
    const dv = { docId: this.data.psInvitation?.limb_msg_id };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        console.error("Error updating Firestore document:", error);
        return error;
      }
    });

    this.matDialogRef.close();

    this.syndicateService.updateInvitationId(this.data.psInvitation?.invitation_id);
    this.syndicateService?.syndicateInvitedDetails$?.subscribe(
      (doc: any) => {
        if (doc?.invited_by) {
          doc.invited_by.onSnapshot((ref) => {
            if (!ref || !ref.id) return;
            doc["invitee"] = ref?.data();
            doc["invitee"]["id"] = ref.id;

            this.syndicateService
              .joinSyndicateInvitation(
                this.data.psInvitation.ps.id,
                doc.invitee.id,
                doc.invitee.id,
                "Declined"
              )
              ?.subscribe(
                (res) => {
                  if (res?.status === "rejected") {
                    this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
                      const defaultMsg = {
                        message: {
                          line_1: "Something went wrong!",
                          line_2: "",
                        },
                        style: {
                          icon: "tick circle error.svg",
                          type: "Error",
                        },
                      };
                      this.authService.showToastMessage(translatedMsg, defaultMsg);
                    }).catch((error) => {
                      return error;
                    });
                    return;
                  }
                  if (res && res?.response && res?.response?.status && res?.response?.status === "Declined") {
                    // Core functionality preserved
                  }
                },
                (err) => {
                  return err;
                }
              );
          });
        }
      },
      (err) => {
        return err;
      }
    );
  }

  close() {
    this.matDialogRef.close();
  }
}
